import Icon from '../components/Icon.vue'

Icon.register({
  sun: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 160c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zM502.4 240.5c12.8 6.4 12.8 24.6-0.2 31.1l-94.7 47.3 33.5 100.4c4.6 13.5-8.3 26.4-21.9 21.9l-100.4-33.5-47.3 94.7c-6.4 12.8-24.6 12.8-31 0l-47.3-94.7-100.4 33.5c-13.5 4.6-26.4-8.3-21.9-21.9l33.5-100.5-94.7-47.3c-12.8-6.4-12.8-24.6 0-31l94.7-47.4-33.5-100.4c-4.6-13.5 8.3-26.4 21.9-21.9l100.5 33.5 47.3-94.7c6.4-12.8 24.6-12.8 31 0l47.4 94.8 100.4-33.5c13.5-4.6 26.4 8.3 21.9 21.9l-33.5 100.4zM346.5 346.5c49.9-49.9 49.9-131.1 0-181s-131.1-49.9-181 0-49.9 131.1 0 181 131.1 49.9 181 0z'
      }
    ]
  }
})
